module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: 'Whole-Home Backup',
      imgSrc: isMobile ? ['solutions_nav_whole_h5.webp', 'solutions_nav_whole_h5.jpg'] : ['solutions_nav_whole.webp', 'solutions_nav_whole.jpg'],
      detLink: "/".concat(locale, "/whole-home-backup-power-solution")
    }, {
      name: 'Power Kits',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }],
    content: {
      headerData: [{
        type: 'large',
        name: 'ما هي Power Kits؟',
        desc: 'سهلة، ذكية ومدمجة',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series")
      }],
      contextList: [{
        type: 'small',
        name: 'محور الطاقة',
        desc: 'محور الطاقة المدمجة 5 أجزاء مع المدخلات والمخرجات',
        imgSrc: isMobile ? ['solutions_list1_h5.webp', 'solutions_list1_h5.jpg'] : ['solutions_list1.webp', 'solutions_list1.jpg'],
        imgHoverSrc: ['solutions_list1_hover.webp', 'solutions_list1_hover.jpg']
      }, {
        type: 'small',
        name: 'بطارية ليثيوم فوسفات الحديد',
        desc: 'سعات تخزين 2-15 كيلو واط في ساعة',
        imgSrc: isMobile ? ['solutions_list2_h5.webp', 'solutions_list2_h5.jpg'] : ['solutions_list2.webp', 'solutions_list2.jpg'],
        imgHoverSrc: ['solutions_list2_hover.webp', 'solutions_list2_hover.jpg']
      }, {
        type: 'small',
        name: 'لوحة توزيع ذكية للتيار المتردد / التيار المستمر',
        desc: '6 + 12 دوائر تيار متردد / تيار مستمر لأجهزتك',
        imgSrc: isMobile ? ['solutions_list3_h5.webp', 'solutions_list3_h5.jpg'] : ['solutions_list3.webp', 'solutions_list3.jpg'],
        imgHoverSrc: ['solutions_list3_hover.webp', 'solutions_list3_hover.jpg']
      }, {
        type: 'small',
        name: 'وحدة التحكم لـPower Kit',
        desc: 'التتعدد والمراقبة والتحكم',
        imgSrc: isMobile ? ['solutions_list4_h5.webp', 'solutions_list4_h5.jpg'] : ['solutions_list4.webp', 'solutions_list4.jpg'],
        imgHoverSrc: ['solutions_list4_hover.webp', 'solutions_list4_hover.jpg']
      }]
    }
  };
};